import { AxiosResponseHeaders } from 'axios';
import { AccountDetails, AccountDetailsResponseDTO } from '../entities';

const accountDetailsResponseDTOToAccountDetailsAdapter = (
  data: AccountDetailsResponseDTO,
  headers?: AxiosResponseHeaders,
): AccountDetails => {
  if (!data.body) {
    throw new Error();
  }

  const { deposit, details } = data.body;

  return new AccountDetails(
    deposit.accountId,
    deposit.accountNumber,
    deposit.alias,
    deposit.productDescription,
    deposit.created,
    deposit.lastUpdated,
    deposit.accountRelationDescription,
    details.beneficiary,
    details.description,
    details.iban,
    details.currentBalance,
    details.availableBalance,
    details.blockedAmount,
    details.withdrawableBalance,
    details.overdraftLimit,
    details.unclearAmount,
    details.accountStatus,
    details.currencyId,
    details.currencyName,
    details.bic,
    details.organizationName,
    details.isEnabled,
  );
};

export { accountDetailsResponseDTOToAccountDetailsAdapter };
